import { SYSDialog, SYSScreen, currentScreenAndDialog, ovl } from "."
import { FocusSet } from "./global/globalapi"
import { _globals } from "./global/globals"
import { DialogCurrentState } from "./library/dialog/dialogapi"
import type { DialogsState } from "./library/dialog/sysdialogbase"
import { SYSField } from "./library/forms/actions"
import { FormInit } from "./library/forms/formapi"
import {
  ScreenCurrent,
  ScreenCurrentState,
  ScreenState,
} from "./library/screenapi"
import { _FocusState } from "./library/sysbaseelement"
import { SYSColumnDef } from "./library/table/tableapi"
import { ReactorFnState, RemoveGlobalReactor } from "./tracker/reactor"
export const handleScreenVisible = async (
  screen: SYSScreen,
  visible: boolean,
  instance?: string
) => {
  if (instance === undefined) {
    instance = screen
  }
  let screensState = ovl.getState().ovl.screens
  let screenState = screensState.screens[screen]
  let screenEl = document.getElementById(`ovlscreen_${screen}_${instance}`)
  if (visible) {
    // switched to visible = true

    if (!screenEl) {
      currentScreenAndDialog.screens.push(
        document.createElement(screenState.tag)
      )
      let screenIndex = currentScreenAndDialog.screens.length
      let el = currentScreenAndDialog.screens[screenIndex - 1]
      el.screen = screen
      el.screenInstance = instance
      el.id = `ovlscreen_${screen}_${instance}`
      const tabIndex = document.createAttribute("tabindex")
      tabIndex.value = "-1"
      el.setAttributeNode(tabIndex)
      el.classList.add("ovl-screen")
      el.classList.add(`ovl-screen-${screen}`)
      el.classList.add("fadeInScreen")
      //_RenderTracking.forceTracking = true
      screensState.nav.screenCounter++
      //_RenderTracking.forceTracking = false
    } else {
      if (screenState.screenCloseBehaviour === "ovl-hide" && screenEl) {
        screenEl.classList.remove("ovl-hide")
        screenEl.classList.remove("fadeOutScreen")
        screenEl.classList.add("fadeInScreen")

        let elsToInit = document.querySelectorAll(
          `#ovlscreen_${screen}_${instance} .ovl-reinitwhenreenter`
        )
        if (elsToInit.length > 0) {
          let lastScreen = screensState.nav.previousScreen
          for (let i = 0; i < elsToInit.length; i++) {
            //@ts-ignore
            if (!(await elsToInit[i].init(lastScreen))) {
              //@ts-ignore
              elsToInit[i].doRender()
            }
          }
        }
      }
      if (screenEl) {
        //screenEl.classList.remove("fadeInScreen")
        //@ts-ignore
        screenEl.firstUpdatedCalled = false
      }
    }
    // set the focus back to where it was when left
    if (screenState.instance?.[instance]?.focus.focusWhenLeft)
      setTimeout(() => {
        FocusSet(screenState.instance[instance].focus.focusWhenLeft, {
          ignoreIfAlreadySetOnScreenOrDialog: true,
        })
      }, 100)
  } else if (screenEl) {
    screenState.instance[instance].focus.focusWhenLeft =
      _globals.lastValidFocusId
    // switched to visible = false
    if (screenState.screenCloseBehaviour === "ovl-hide") {
      screenEl.classList.add("ovl-hide")
      screenEl.classList.remove("fadeOutScreen")
      screenEl.classList.remove("ovl-disabled")
    } else {
      let screenIndex = currentScreenAndDialog.screens.findIndex(
        (w) => w.screen === screen
      )
      currentScreenAndDialog.screens.splice(screenIndex, 1)

      //_RenderTracking.forceTracking = true
      screensState.nav.screenCounter++

      //_RenderTracking.forceTracking = false
    }
    screenState.instance[instance].focus.focusSet = false
  }
}

export const _handleDialogVisible = (context: ReactorFnState) => {
  // we are just interested in the visible prop
  let p = context.hitPath.split(".")
  let dialog = <SYSDialog>p[p.length - 4]
  let instance = <SYSDialog>p[p.length - 2]
  let dialogsState = context.state.ovl.dialogs
  let dialogState: DialogsState =
    context.state.ovl.dialogs[dialog].instance[instance]

  if (!dialogState) {
    return
  }
  let dialogEl = document.getElementById(`ovldialog_${dialog}_${instance}`)
  if (context.value) {
    // open dialog
    //if (!dialogEl) {
    //disable shellbar and make it non clickable as long at least one dialog is open
    let shellbars = document.getElementsByClassName("fd-shellbar")
    if (shellbars.length > 0) {
      shellbars[0].classList.add("ovl-disabled")
    }

    let currentDialog = document.createElement(dialogsState[dialog].tag)

    currentScreenAndDialog.dialogs[`${dialog}@@Ovl${instance}`] = currentDialog
    //@ts-ignore
    currentDialog.dialog = dialog
    //@ts-ignore
    currentDialog.dialogInstance = instance

    currentDialog.id = `ovldialog_${dialog}_${instance}`

    // if (!dialogState.zIndex) {
    //   let dlgsCount = Object.keys(currentScreenAndDialog.dialogs).length
    //   dialogState.zIndex = 6 + dlgsCount
    // }

    //if a formshandling matches exactly to this dialog then set do it already here
    if (dialogState.formsHandling) {
      //explicitly connected
      let formHandling = dialogState.formsHandling.filter(
        (f) => f.isConnectedToDialog
      )
      if (formHandling.length > 0) {
        //@ts-ignore
        currentDialog.formType = formHandling[0].formType
        //@ts-ignore
        currentDialog.formId = formHandling[0].formId
        //@ts-ignore
        currentDialog.formState =
          context.state.ovl.forms[formHandling[0].formType][
            formHandling[0].formId
          ]
      }
    }

    //context.state.ovl.screens.nav.dialogCounter++
    // reset focusSet
    let focusState: _FocusState
    //let forceFocus
    let currentDialogStates = DialogCurrentState()
    if (currentDialogStates.length === 0) {
      let screenState = ScreenCurrentState()
      focusState = screenState?.focus
    } else {
      focusState = currentDialogStates[0].focus
      //forceFocus = currentDialogStates[0].forceElementIdToFocusAfterClose
    }
    if (focusState && !focusState.focusWhenLeft) {
      focusState.focusSet = false
      focusState.focusWhenLeft = _globals.lastValidFocusId
      // focusState.focusWhenLeft =
      //   forceFocus !== undefined ? forceFocus : _globals.lastValidFocusId
    }
    currentScreenAndDialog.dialogFocusSet.dialog = dialog
    currentScreenAndDialog.dialogFocusSet.instance = instance
    //}
  } else if (dialogEl) {
    // close dialog
    delete currentScreenAndDialog.dialogs[`${dialog}@@Ovl${instance}`]

    if (dialogState.formsHandling) {
      dialogState.formsHandling.forEach((f) => {
        if (f.removeFormStateWhenClose) {
          context.actions.ovl.form._RemoveForm({
            formType: f.formType,
            formId: f.formId,
          })
        }
      })
      dialogState.formsHandling = undefined
    }
    dialogState.resolver = undefined
    dialogState.focus.focusSet = false
    dialogState.closing = false

    let currentDialogStates = DialogCurrentState()
    let focusState: _FocusState
    if (currentDialogStates.length < 2) {
      // focusWhenLeft is from screen
      focusState = ScreenCurrentState()?.focus

      // no more dialogs open, make shellbar accesible again
      let shellbars = document.getElementsByClassName("fd-shellbar")
      if (shellbars.length > 0) {
        shellbars[0].classList.remove("ovl-disabled")
      }
    } else {
      // there is an underlying dialog. so set focus back from the item when dialog was opened

      focusState = currentDialogStates[1].focus
    }
    RemoveGlobalReactor([`ovl.dialogs.${dialog}.instance.${instance}.visible`])
    delete ovl.getState().ovl.dialogs[dialog].instance[instance]

    if (focusState?.focusWhenLeft) {
      setTimeout(() => {
        FocusSet(focusState.focusWhenLeft, {
          ignoreIfAlreadySetOnScreenOrDialog: true,
          preventScroll: true,
        })
        focusState.focusWhenLeft = undefined
      }, 50)
    }
  }

  // important, setting dialog.visible will be caught in here using a reactor (btw. its a todo to change that and just use the actions)
  // that means the visible valueis not written back to state at this point (reactor can cancel setting of value)
  // that means we need do trigger the rerender of the dialog after this code runs, thus the settimeout
  setTimeout(() => {
    context.state.ovl.screens.nav.dialogCounter++
  }, 0)
}

export const _controlInit = (col: SYSColumnDef | SYSField) => {
  if (col.type === "asset") {
    col.control = "asset"
    if (col.editor === undefined) {
      col.editor = { id: "SYSEditorAsset" }
    }
  }
  if (
    col.control === "checkbox" ||
    (col.control === undefined && col.type === "bool")
  ) {
    if (col.ui.checkedValue === undefined) {
      col.ui.checkedValue = true
    }

    if (col.type === undefined) {
      if (typeof col.ui.checkedValue === "string") {
        col.type = "text"
      } else {
        col.type = "bool"
      }
    }
  }
  if (col.control === undefined) {
    if (col.type === "datetime") {
      col.control = "datetime"
    } else if (col.list) {
      col.control = "list"
      if (col.list.mode === "Option") {
        col.control = "option"
      }
    } else {
      if (col.ui?.checkedValue) {
        col.control = "checkbox"
      } else {
        col.control = "text"
      }
    }
  }
}
